import React from 'react'

import classes from './Input.css'

const input = (props) => {
  let inputElement = null;
  let errorMessage = null;
  const inputClasses = [classes.Input]

  if (props.focused && !props.invalid) {
    inputClasses.push(classes.Focus)
  }

  if (props.invalid && props.touched) {
    inputClasses.push(classes.Invalid)

    switch (props.validationObj.type) {
      case ('email'):
        errorMessage = <p className={classes.Error}>{props.translations ?
          props.translations.label_error_email_field :
          'Indirizzo email non valido!'}</p>
        break;
      case ('number'):
        errorMessage = <p className={classes.Error}>{props.translations ?
          props.translations.label_error_phone_field
          : 'Numero di telefono non valido!'}</p>
        break;
      case 'name':
        errorMessage = <p className={classes.Error}>{props.translations ?
          props.translations.label_error_name_field
          : 'Numero di telefono non valido!'}</p>
        break;
      case 'surname':
        errorMessage = <p className={classes.Error}>{props.translations ?
          props.translations.label_error_surname_field
          : 'Numero di telefono non valido!'}</p>
        break;
      default:
        errorMessage = null;
    }
  }

  switch (props.elementType) {
    case ('input'):
      inputElement = <input
        className={classes.InputElement}
        {...props.elementConfig}
        value={props.value}
        onChange={props.changed}
        ref={r => props.setReference(r)}
      />
      break;
    case ('textarea'):
      inputElement = <textarea
        className={[classes.InputElement, classes.TextArea].join(' ')}
        {...props.elementConfig}
        value={props.value}
        onChange={props.changed} />
      break;
    default:
      inputElement = <input
        className={classes.InputElement}
        {...props.elementConfig}
        value={props.value}
        onChange={props.changed} />
  }
  return (
    <div>
      <div className={inputClasses.join(' ')}>
        <label className={classes.Label}>{props.label}</label>
        {inputElement}
      </div>
      {errorMessage}
    </div>
  )
}

export default input;


// WEBPACK FOOTER //
// ./src/components/UI/Input/Input.js